<div>
   
    <div *ngIf="loading" class="text-center py-3">
        <span class="spinner-border spinner-border-sm" role="status"></span> Chargement...
    </div>
    <div *ngIf="error" class="alert alert-warning mb-2">{{ error }}</div>
    <table class="table table-hover" *ngIf="!loading">
        <thead class="align-middle custom-header">
            <tr class="text-start">
                <th class="uppercase">Référence</th>
                <th>Date</th>
                <th>MONTANT TTC</th>
                <th>MONTANT RESTANT</th>
                <th class="uppercase">ACTIONS</th>
            </tr>
        </thead>
        <tbody>
            <tr class="ligne text-start" *ngFor="let avoir of avoirs">
                <td class="titre1 padd">{{ avoir.reference || avoir.ref_externe || '—' }}</td>
                <td class="titre3 padd">{{ avoir.date | date: 'dd/MM/yyyy' }}</td>
                <td class="titre3 padd">{{ getMontant(avoir) }} TND</td>
                <td class="titre3 padd">{{ getMontantRestant(avoir) }} TND</td>
                <td class="titre3 padd">
                    <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="utiliserAvoir(avoir)" title="Pré-remplir le formulaire de paiement">
                        Utiliser
                    </button>

                </td>
            </tr>
            <tr *ngIf="!loading && avoirs.length === 0 && !error">
                <td colspan="5" class="text-center text-muted py-3">Aucun avoir émis à partir de cette facture.</td>
            </tr>
        </tbody>
    </table>
</div>
